import React, { useEffect } from 'react'
import Button from '@mui/material/Button';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Box, Grid, TextField, Toolbar, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserOwnProfile } from '../../store/userSlice';

export default function MyProfile({ setProfileModal, selectedUser = null }) {
    const [initialState, setiInitialState] = React.useState({});
    const [isButtonDisabled, setIsButtonDisabled] = React.useState();
    const rolesList = useSelector((state) => state.roleReducer.rolesData)
    const userData = useSelector((state) => selectedUser ? selectedUser : state.userReducer?.userData)
    const dispatch = useDispatch()

    const validationSchema = Yup.object({
        username: Yup.string()
            .required("Username is required")
            .min(3, "Username must be at least 3 characters"),
        email: Yup.string()
            .required("Email is required")
            .matches(
                /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                "Enter a valid email address"
            ),
        role_id: Yup.string()

    });
    const formik = useFormik({
        initialValues: initialState,
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            console.log("Form Submitted:", values, userData);
            values.uuid = userData?.uuid
            dispatch(updateUserOwnProfile(values))
            setProfileModal && setProfileModal(false)
        },
    });

    useEffect(() => {
        if (userData) {
            formik.setFieldValue('username', userData.username);
            formik.setFieldValue('email', userData.email);
            setiInitialState(userData)
        }
    }, [userData])
    console.log("role list", rolesList);
    const handleClose = () => {
        setProfileModal && setProfileModal(false)
    };
    useEffect(() => {
        const disabled = JSON.stringify({
            'username': formik.values.username,
            'email': formik.values.email
        }) === JSON.stringify({
            'username': userData.username,
            'email': userData.email
        });
        setIsButtonDisabled(disabled)
        console.log("formik.values", formik.values);
        console.log("formik.initialValues", disabled);
    }, [userData, formik.values])

    return (
        <>
            <Toolbar
                className='main-list-toolbar'
            >
                <Typography
                    className="d-flex flex-grow-1 flex-shrink-1 flex-fill"
                    variant="h6"
                    id="tableTitle"
                    component="div"
                >
                    Profile
                </Typography>
            </Toolbar>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={4}>
                    {formik.values &&
                        <Box
                            component="form"
                            onSubmit={formik.handleSubmit}
                            className='mw-100'
                        >
                            <TextField
                                fullWidth
                                required
                                id="userName"
                                name="username"
                                label="User Name"
                                margin="normal"
                                variant="outlined"
                                value={formik.values.username}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.username && Boolean(formik.errors.username)}
                                helperText={formik.touched.username && formik.errors.username}
                            />
                            <TextField
                                fullWidth
                                required
                                id="email"
                                name="email"
                                label="Email"
                                type="email"
                                margin="normal"
                                variant="outlined"
                                value={formik.values.email}
                                // onChange={formik.handleChange}
                                onChange={(e) => {
                                    const lowerCaseEmail = e.target.value.toLowerCase();
                                    formik.setFieldValue("email", lowerCaseEmail);
                                }}
                                onBlur={formik.handleBlur}
                                error={formik.touched.email && Boolean(formik.errors.email)}
                                helperText={formik.touched.email && formik.errors.email}
                            />
                            <Box display="flex" gap={2} justifyContent="flex-end" className="mt-4">
                                <Button onClick={handleClose} type="submit" variant="contained" disabled={isButtonDisabled || !formik.isValid}>
                                    Save
                                </Button>
                            </Box>
                        </Box>
                    }
                </Grid>
            </Grid>
        </>
    );
}